import { tryCatch } from '@youkeeps/shared';
import axios, { type AxiosResponse } from 'axios';

type RequestMethod = 'get' | 'post' | 'put' | 'patch' | 'delete';

export type Response<T> = {
  data: T;
  status?: {
    text: AxiosResponse['statusText'];
    code: AxiosResponse['status'];
  };
};

export async function baseRequest<T>(options: {
  requestType: RequestMethod;
  url: string;
  queryParams?: Record<string, unknown>;
  body?: Record<string, unknown>;
  headers?: Record<string, unknown>;
}): Promise<Response<T>> {
  const { requestType, url, body, queryParams, headers } = options;

  const response = await tryCatch(
    axios<T>({
      method: requestType,
      url,
      params: queryParams,
      data: body,
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        'Content-Type': 'application/json',
        ...headers,
      },
    }),
  );

  if (response.error) {
    throw response.error;
  }

  return {
    data: response.data.data,
    status: {
      text: response.data.statusText,
      code: response.data.status,
    },
  };
}
